import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Table, Button, Popup } from 'semantic-ui-react';
import i18next from 'i18next';

import './DayCellOptions.scss';

class DayCellOptions extends Component {

    render() {
        const { removeSegment } = this.props;

        return (
            <Table.Cell
                textAlign='center'
                singleLine
                className='pi-week-scheduler-options-cell' >
                <Popup
                    trigger={<Button circular negative icon='trash' onClick={removeSegment} />}
                    content={i18next.t('schedule.removeSegment')}
                    inverted
                    position='top center'
                />
                
            </Table.Cell>
        );
    }
}

DayCellOptions.propTypes = {
    segment: PropTypes.object,
    removeSegment: PropTypes.func,
    
};

export default DayCellOptions;